import React from 'react';
import BioVitalDetailList from './BioVitalDetailList';

// Sugar (blood glucose) detail list (reached from /user-bio-vitals Sugar Count drill-down).
const SugarDetailsList = () => (
  <BioVitalDetailList config={{
    title: 'Sugar (Blood Glucose) Details',
    routePath: '/sugar-details',
    endpoint: '/admin/api/sugar-details',
    valueLabel: 'Sugar',
    valueKey: 'sugar',
    dateLabel: 'Datetime',
    dateKey: 'timestamp_utc',
    dateFmt: 'utc',
    totalLabel: 'Total Sugar',
    breadcrumbType: 'Sugar',
    exportName: 'sugar-details.csv',
  }} />
);

export default SugarDetailsList;
